import { call, put } from 'redux-saga/effects'
import * as api from "../../services/api";
import PaymentTrackActions from './payment-track.actions'

export function* getPaymentTrackRange(action) {
    const { businessId, startDate, endDate, options } = action
    // make the call to the api
    const response = yield call(api.getPaymentTrackRange, businessId, startDate, endDate, options)

    // success?
    if (response.ok) {
        yield put(PaymentTrackActions.paymentTrackRangeSuccess(response.data))
    } else {
        yield put(PaymentTrackActions.paymentTrackRangeFailure(response.data))
    }
}

export function* getCollectedPaymentTracks(action) {
    const { businessId, filter, options } = action;
    // make the call to the api
    const response = yield call(api.getCollectedPaymentTrack, businessId, filter, options);
    // success?

    if (response.ok) {
        yield put(PaymentTrackActions.collectedPaymentTrackSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.collectedPaymentTrackFailure(response.data));
    }
}

export function* getMissedPaymentTrack(action) {
    const { businessId, filter, options } = action;
    // make the call to the api
    const response = yield call(api.getMissedPaymentTrack, businessId, filter, options);
    // success?
    if (response.ok) {
        yield put(PaymentTrackActions.missedPaymentTrackSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.missedPaymentTrackFailure(response.data));
    }
}

export function* getExternalPaymentTrack(action) {
    const { businessId, filter, options } = action;
    // make the call to the api
    const response = yield call(api.getExternalPaymentTrack, businessId, filter, options);
    // success?
    if (response.ok) {
        yield put(PaymentTrackActions.externalPaymentTrackSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.externalPaymentTrackFailure(response.data));
    }
}


export function* getAccountsPaymentSearch(action) {
    const { businessId, filter, options } = action;
    const response = yield call(api.getAccountsPaymentSearch, businessId, filter, options);
    if (response.ok) {
        yield put(PaymentTrackActions.accountsPaymentSearchSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.accountsPaymentSearchFailure(response.data));
    }
}

export function* getAccountsPaymentCSV(action) {
    const { businessId, query, options } = action;
    const response = yield call(api.getAccountsPaymentCSV, businessId, query, options);
    if (response.ok) {
        yield put(PaymentTrackActions.accountsPaymentCsvSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.accountsPaymentCsvFailure(response.data));
    }
}

export function* getAccountsPaymentPDF(action) {
    const { businessId, membershipId, query, options } = action;
    const response = yield call(api.getAccountsPaymentPDF, businessId, membershipId, query, options);
    if (response.ok) {
        yield put(PaymentTrackActions.accountsPaymentPdfSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.accountsPaymentPdfFailure(response.data));
    }
}

export function* getPaymentTracksCsv(action) {
    const { businessId, membershipId, query, options } = action;
    const response = yield call(api.getCollectedPaymentCSV, businessId, membershipId, query, options);
    if (response.ok) {
        yield put(PaymentTrackActions.paymentTracksCsvSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.paymentTracksCsvFailure(response.data));
    }
}

export function* getPaymentTracksPdf(action) {
    const { businessId, membershipId, query, options } = action;
    const response = yield call(api.getCollectedPaymentPDF, businessId, membershipId, query, options);
    if (response.ok) {
        yield put(PaymentTrackActions.paymentTracksPdfSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.paymentTracksPdfFailure(response.data));
    }
}

export function* getAccountsPaymentTotals(action) {
    const { businessId, query, options } = action;
    const response = yield call(api.getAccountsPaymentTotals, businessId, query, options);
    if (response.ok) {
        yield put(PaymentTrackActions.accountsPaymentTotalsSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.accountsPaymentTotalsFailure(response.data));
    }
}

export function* getTrackAttrributions(action) {
    const { paymentTrackId } = action;

    // make the call to the api
    const response = yield call(api.getPaymentAttributions, paymentTrackId);

    // success?
    if (response.ok) {
        yield put(PaymentTrackActions.paymentAttributionsSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.paymentAttributionsFailure(response.data));
    }
}

export function* getFilteredDataTotals(action) {
    const { businessId, filter, options } = action;

    // make the call to the api
    const response = yield call(api.getFilteredDataTotals, businessId, filter, options);

    // success?
    if (response.ok) {
        yield put(PaymentTrackActions.filteredDataTotalsSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.filteredDataTotalsFailure(response.data));
    }
}

export function* getPlanPaymentSummary(action) {
    const { businessId, startDate, endDate } = action;
    const response = yield call(api.getPlanPaymentSummary, businessId, startDate, endDate);
    if (response.ok) {
        yield put(PaymentTrackActions.planPaymentSummarySuccess(response.data));
    } else {
        yield put(PaymentTrackActions.planPaymentSummaryFailure(response.data));
    }
}

export function* getPlanReconciliationSummary(action) {
    const { businessId, startDate, endDate } = action;
    const response = yield call(api.getPlanReconciliationSummary, businessId, startDate, endDate);
    if (response.ok) {
        yield put(PaymentTrackActions.planReconciliationSummarySuccess(response.data));
    } else {
        yield put(PaymentTrackActions.planReconciliationSummaryFailure(response.data));
    }
}

export function* getExternalColleagueSummary(action) {
    const { businessId, startDate, endDate, membershipId } = action;
    const response = yield call(api.getExternalColleagueSummary, businessId, startDate, endDate, membershipId);
    if (response.ok) {
        yield put(PaymentTrackActions.externalColleagueSummarySuccess(response.data));
    } else {
        yield put(PaymentTrackActions.externalColleagueSummaryFailure(response.data));
    }
}

export function* getExternalColleagueSummaryCsv(action) {
    const { businessId, startDate, endDate, membershipId } = action;
    const response = yield call(api.getExternalColleagueSummaryCsv, businessId, startDate, endDate, membershipId);
    if (response.ok) {
        yield put(PaymentTrackActions.externalColleagueSummaryCsvSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.externalColleagueSummaryCsvFailure(response.data));
    }
}

export function* getExternalColleagueSummaryPdf(action) {
    const { businessId, membershipId, startDate, endDate, recordedById } = action;
    const response = yield call(
        api.getExternalColleagueSummaryPdf,
        businessId,
        membershipId,
        startDate,
        endDate,
        recordedById
    );
    if (response.ok) {
        yield put(PaymentTrackActions.externalColleagueSummaryPdfSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.externalColleagueSummaryPdfFailure(response.data));
    }
}

export function* getPaymentTracksSummaryPdf(action) {
    const { businessId, membershipId, startDate, endDate } = action;
    const response = yield call(api.getPaymentsSummaryPdf, businessId, membershipId, startDate, endDate);
    if (response.ok) {
        yield put(PaymentTrackActions.paymentTracksSummaryPdfSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.paymentTracksSummaryPdfFailure(response.data));
    }
}

export function* getPaymentTracksReconciliationPdf(action) {
    const { businessId, membershipId, startDate, endDate } = action;
    const response = yield call(api.getReconciliationSummaryPdf, businessId, membershipId, startDate, endDate);
    if (response.ok) {
        yield put(PaymentTrackActions.paymentTracksReconciliationPdfSuccess(response.data));
    } else {
        yield put(PaymentTrackActions.paymentTracksReconciliationPdfFailure(response.data));
    }
}
